import { Container, Breadcrumbs as MuiBreadcrumbs } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import classNames from 'classnames';
import { getCountryCode, isFeatureEnabled } from '~/shared/utils';
import { useBreadcrumbsContext } from '~/shared/contexts';
import { useFlags, useIsDesktop } from '~/shared/hooks';
import { Button, Icon } from 'components';
import Link from 'next/link';
import { useRouter } from 'next/router';
import React from 'react';
import { useIntl } from 'react-intl';

const useStyles = makeStyles((theme) => ({
    breadcrumbsContainer: {
        width: '100%',
        maxWidth: theme.containerMaxWidths.xl,
        margin: `${theme.spacing(3)}px auto`,
        padding: theme.spacing(0, 4),
        [theme.breakpoints.down('lg')]: {
            padding: theme.spacing(0, 2)
        },
        [theme.breakpoints.down('md')]: {
            padding: theme.spacing(0, 2),
            margin: `${theme.spacing(1)}px auto`
        }
    },
    breadcrumb: {
        maxWidth: '300px',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        [theme.breakpoints.down('md')]: {
            maxWidth: '230px'
        }
    },
    breadcrumbLink: {
        color: 'rgba(0, 0, 0, 0.87)',
        fontWeight: 400,
        textDecoration: 'none'
    },
    currentBreadcrumb: {
        color: theme.palette.grey.main,
        pointerEvents: 'none',
        cursor: 'default'
    }
}));

export const Breadcrumbs = () => {
    const { breadcrumbs, lastParentBreadcrumb } = useBreadcrumbsContext();
    const classes = useStyles();
    const { locale } = useIntl();
    const { learningBreadcrumbsTemp11042025 } = useFlags();
    const router = useRouter();
    const isDesktop = useIsDesktop();

    if (
        !learningBreadcrumbsTemp11042025 ||
        breadcrumbs.length === 0 ||
        !isFeatureEnabled('breadcrumbs', getCountryCode(locale))
    ) {
        return null;
    }

    if (!isDesktop) {
        const toNavigate = lastParentBreadcrumb?.href;
        if (!toNavigate) {
            return null;
        }
        return (
            <Container className={classes.breadcrumbsContainer}>
                <Link href={toNavigate} className={classes.breadcrumbLink}>
                    <Button
                        size="small"
                        variant="ghost"
                        onlyIcon
                        endIcon={<Icon icon="arrowLeft" />}
                    />
                </Link>
            </Container>
        );
    }

    return (
        <Container className={classes.breadcrumbsContainer}>
            <MuiBreadcrumbs aria-label="breadcrumb" classes={{ li: classes.breadcrumb }}>
                {breadcrumbs.map((breadcrumb) => (
                    <Link
                        key={`breadcrumb-${breadcrumb.href}`}
                        href={breadcrumb.href}
                        className={classNames(classes.breadcrumbLink, {
                            [classes.currentBreadcrumb]: breadcrumb.href === router.asPath
                        })}
                    >
                        {breadcrumb.label}
                    </Link>
                ))}
            </MuiBreadcrumbs>
        </Container>
    );
};
